import { render, staticRenderFns } from "./PostBanner.vue?vue&type=template&id=56b96bae&scoped=true&"
import script from "./PostBanner.vue?vue&type=script&lang=js&"
export * from "./PostBanner.vue?vue&type=script&lang=js&"
import style0 from "./PostBanner.vue?vue&type=style&index=0&id=56b96bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b96bae",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostBanner.vue
// module id = 106
// module chunks = 0